import React from 'react';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';
import { ISubscriptionCardCommonProps } from '../types';

import AdditionalStatusInfo from './subComponents/AdditionalStatusInfo';
import BillingPeriod from './subComponents/BillingPeriod';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import PeriodRow from './subComponents/PeriodRow';
import PriceRow from './subComponents/PriceRow';
import SubscriptionCardHeader from './subComponents/SubscriptionCardHeader';
import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import SubscriptionCardWrapper from './SubscriptionCardWrapper';

import * as S from './styled';

const UpdatingSubscription = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    isTrial,
    isUpgrade,
    isMainSubscription,
    productCode,
    captions,
}: ISubscriptionCardCommonProps) => {
    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader
                isMainSubscription={isMainSubscription}
                productCode={productCode}
                Icon={tabIcon}
                heading={heading}
            />
            <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.UPDATING} />
            <PeriodRow period={subscriptionPeriod} isTrial={isTrial} />
            <PriceRow price={price} />
            <BillingPeriod period={subscriptionPeriod} />
            {isUpgrade && <IncludedInYourPlanRow isCardRow />}
            <S.Line $mt={16} />
            {captions?.description && <AdditionalStatusInfo captions={captions} mb={0} />}
        </SubscriptionCardWrapper>
    );
};

export default UpdatingSubscription;
